import { Component } from '@angular/core';

@Component({
  selector: 'app-checkbox-showcase',
  templateUrl: './checkbox-showcase.component.html',
  styleUrls: ['./checkbox-showcase.component.scss']
})
export class CheckboxShowcaseComponent {
  basicChecked = false;
  basicIndeterminate = false;

  disabledUnchecked = false;
  disabledChecked = true;

  errorChecked = false;
  errorUnchecked = false;

  interactiveCheckboxes = [
    { id: 1, label: 'Feature 1', checked: false },
    { id: 2, label: 'Feature 2', checked: true },
    { id: 3, label: 'Feature 3', checked: false },
    { id: 4, label: 'Feature 4', checked: true }
  ];

  selectAllChecked = false;
  allSelected = false;

  onCheckboxChange(checkbox: any, value: boolean): void {
    checkbox.checked = value;
    this.updateSelectAll();
  }

  onSelectAll(value: boolean): void {
    this.selectAllChecked = value;
    this.interactiveCheckboxes.forEach(cb => cb.checked = value);
    this.updateSelectAll();
  }

  updateSelectAll(): void {
    const allChecked = this.interactiveCheckboxes.every(cb => cb.checked);
    const anyChecked = this.interactiveCheckboxes.some(cb => cb.checked);
    this.allSelected = allChecked;
  }

  getSelectedCount(): number {
    return this.interactiveCheckboxes.filter(cb => cb.checked).length;
  }

  getSelectedLabels(): string {
    return this.interactiveCheckboxes
      .filter(cb => cb.checked)
      .map(cb => cb.label)
      .join(', ');
  }
}
